export default __webpack_public_path__ + "static/media/shandianqinglidashi_page.898b2036.png";